import TableList from "@components/templates/tablelist";
import { HttpInventoryVolumeList } from "@/service/tasks";
import { mapGetters } from 'vuex';
import mixin from '../mixin'
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90
            },
            formData: {
                state: 0
            },
            exportData: {},
            Plugins: { show: true }
        };
    },

    methods: {
        ajaxRequest: HttpInventoryVolumeList,
        interceptRequest(params){
            delete params.search.undefined;
            this.exportData = params;
            return params
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$Message.error({
                        content: this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }),
                        duration: 30,
                        closable: true,
                    });
            }
            switch (type) {
                case "export":
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/inventory/volumeSnapshot/export", {...this.exportData, state: 0},
                        {
                            executor: "request",
                            download: true,
                            method: 'get'
                        }
                    );
                break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList', 'getTransferWarehouse','getAdminTransferWarehouse']),
        ToolsData() {
            return [
                {
                    label: this.$t('global.common.export',{defaultValue:'导出'}),
                    operate: "export",
                },
            ];
        },
        SearchsData() {
            return [
                // {
                //     label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                //     key: 'IN_orgWarehouseId',
                //     tag: 'Select',
                //     options: this.getTransferWarehouse,
                //     props: {
                //         filterable: true,
                //         multiple: true,
                //     },
                //     show: true,
                //     style: "width:250px",
                // },
                {
                    label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                    tag: 'div',
                    show:true,
                    children:(h)=>{
                        return h("compMultipleSelect",{
                            props: {
                                options:this.getTransferWarehouse,
                                modelValue:this.formData.search.IN_orgWarehouseId,
                                placeholder:this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                                // isShowCheckAll:false,//是否展示全选按钮
                            },
                            on:{
                                'update:modelValue':(val)=>{
                                    this.formData.search.IN_orgWarehouseId = val
                                }
                            }
                        })
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('fbb.inventory.snap_shot_date', { defaultValue: "库存快照日期" }),
                    tag: 'vDatepicker',
                    key: 'BT_fetchDate',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    show: true,
                    style: "width:250px",
                },
            ];
        },
        columns() {
            return [
                {
                    title: 'No',
                    type: 'index',
                    width: 60
                },
                {
                    title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
                    render: (h, { row }) => {
                        let orgWarehouseCode = row.orgWarehouseCode
                        const { label } = this.getTransferWarehouse.find(function (item) { return item.attach.code == orgWarehouseCode}) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.inventory.total_volume_product', { defaultValue: "产品总体积（CBM）" }),
                    key: 'volume'
                },
                {
                    title: this.$t('fbb.inventory.snap_shot_date', { defaultValue: "库存快照日期" }),
                    key: 'fetchDate'
                },
                {
                    title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                    key: 'createdAt',
                }
            ];
        }
    }
};
